import { createTheme, rem } from "@mantine/core";

/**
 * PriceWatch Mantine theme — PRD Section 3 design standard.
 * "Information-dense without being cluttered. Publication-quality data visualization."
 * Typography: system font stack, 4-5 size scale, strict hierarchy.
 * Spacing: 8px grid. Color: constrained palette for price change semantics.
 */
export const theme = createTheme({
  primaryColor: "blue",

  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  headings: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontWeight: "600",
    sizes: {
      h1: { fontSize: rem(28), lineHeight: "1.3" },
      h2: { fontSize: rem(22), lineHeight: "1.35" },
      h3: { fontSize: rem(18), lineHeight: "1.4" },
      h4: { fontSize: rem(16), lineHeight: "1.45" },
    },
  },

  fontSizes: {
    xs: rem(11),
    sm: rem(13),
    md: rem(14),
    lg: rem(16),
    xl: rem(20),
  },

  spacing: {
    xs: rem(4),
    sm: rem(8),
    md: rem(16),
    lg: rem(24),
    xl: rem(32),
  },

  radius: {
    xs: rem(2),
    sm: rem(4),
    md: rem(8),
    lg: rem(12),
    xl: rem(16),
  },

  colors: {
    // Price change semantic colors (used in badges and indicators)
    priceDecrease: [
      "#e6f9ed", "#c3f0d4", "#8be4a8", "#52d67c", "#2bc960",
      "#15b84a", "#0ea13e", "#087a2f", "#065c24", "#043d18",
    ],
    priceIncrease: [
      "#fde8e8", "#facbcb", "#f49898", "#ee6565", "#e83d3d",
      "#d92626", "#b81e1e", "#8c1717", "#6a1111", "#470b0b",
    ],
    promo: [
      "#fff8e1", "#ffecb3", "#ffe082", "#ffd54f", "#ffca28",
      "#ffc107", "#ffb300", "#ff8f00", "#ff6f00", "#e65100",
    ],
    oos: [
      "#f8f9fa", "#e9ecef", "#dee2e6", "#ced4da", "#adb5bd",
      "#868e96", "#495057", "#343a40", "#212529", "#0a0a0a",
    ],
  },

  defaultRadius: "sm",

  components: {
    Card: {
      defaultProps: {
        padding: "md",
        withBorder: true,
      },
    },
    Table: {
      defaultProps: {
        striped: true,
        highlightOnHover: true,
        withTableBorder: true,
        withColumnBorders: false,
      },
    },
    Badge: {
      defaultProps: {
        variant: "light",
        size: "sm",
      },
    },
  },
});
